import React from 'react';
import { Box } from '@mui/joy';
import { ContactDetail } from '../../components/crm/contacts/ContactDetail';

export const ContactDetailPage: React.FC = () => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <ContactDetail />
    </Box>
  );
};
